import { render, staticRenderFns } from "./ConceptsApplyAllModal.vue?vue&type=template&id=8bc01410&scoped=true"
import script from "./ConceptsApplyAllModal.vue?vue&type=script&lang=ts"
export * from "./ConceptsApplyAllModal.vue?vue&type=script&lang=ts"
import style0 from "./ConceptsApplyAllModal.vue?vue&type=style&index=0&id=8bc01410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc01410",
  null
  
)

export default component.exports